import * as React from "react"
import { Block } from "./library/container"
import { Link } from "./library/link"

export interface ButtonBlockProps {
  readonly kind: "knop"
  readonly caption: string
  readonly href: string
}

export const ButtonBlock: (props: ButtonBlockProps) => JSX.Element = p => (
  <Block>
    <div className="cta">
      <Link url={p.href} className={`button`}>{p.caption}</Link>
    </div>
  </Block>
)
